import Paper from "@mui/material/Paper"
import Stack from "@mui/material/Stack"
import { observer } from "mobx-react-lite"
import { ReactNode } from "react"
import { themeConfig } from '@gap/shared/theme'

interface CentredBannerProps {
   callToAction?: ReactNode
}

export default observer(function CentredBanner({ children, callToAction }: React.PropsWithChildren<CentredBannerProps>) {

   return <Paper sx={{
      width: '100%',
      maxWidth: themeConfig.breakpoints.values.lg,
      backgroundColor: "white",
      px: 3,
      py: { xs: 2, sm: 1 },
      border: `1px solid ${themeConfig.primary['200']}`,
      boxShadow: '0px 1px 4px 0px #00000026',
   }}>
      <Stack sx={{
         gap: 2,
         flexDirection: { xs: 'column', sm: 'row' },
         alignItems: 'center',
         justifyContent: 'center',
      }}>
         <Stack sx={{ flexDirection: 'row' }}>
            {children}
         </Stack>
         {callToAction && <Stack sx={{
            flexDirection: 'row',
            flexShrink: 0,
            alignSelf: { xs: 'stretch' },
            alignItems: 'stretch',
            '> *': { flexGrow: 1 },
         }}>
            {callToAction}
         </Stack>}
      </Stack>
   </Paper>
})
